import React from "react";
import CooperationStatus from "./CooperationStatus";
import SiteStatus from "./SiteStatus";
// import SafetyStatus from "./SafetyStatus";
import RepeaterStatus from "./RepeaterStatus";
import { Content } from "../layout";

const Dashboard = () => {
  return (
    <Content>
      <CooperationStatus />
      <SiteStatus />
      {/* <RepeaterStatus /> */}
      {/* <SafetyStatus /> */}
    </Content>
  );
};

export default Dashboard;
